import React from 'react';
import { Redirect, useParams } from "react-router-dom";
import { Itemset } from "../../store/viewmodels/ItemsetViewModel";
import { Item } from "../../store/viewmodels/ItemViewModel";
import { Task } from "../../store/viewmodels/TaskViewModel";
import { getItem } from "../../utils/TaskContentServices"
import StudentOneChoiceItem from "./items/StudentOneChoiceItem";
import StudentVideoInstructionItem from "./items/StudentVideoInstructionItem";
import StudentFindErrorItem from "./items/StudentFindErrorItem";
import CombineItem from "./items/Combine/StudentCombineItem";
import StudentMemoryGameItem from "./items/MemoryGame/StudentMemoryGameItem";
import StudentVideoRecording from './items/VideoRecording/StudentVideoRecording';
import ProgressBar from './ProgressBar';
import StudentOrganizeItem from './items/Organize/StudentOrganizeItem';


interface StudentItemParams {
    itemId: string
}

interface StudentItemProps {
    task: Task,
    itemset: Itemset
}

function StudentItem(props: StudentItemProps) {

    React.useEffect(() => {
        const alertUser = (e: any) => {
            e.preventDefault();
            e.returnValue = '';
        }
        window.addEventListener('beforeunload', alertUser);

        return () => window.removeEventListener('beforeunload', alertUser)
    }, [])

    let { itemId } = useParams<StudentItemParams>();
    let item: Item = getItem(props.itemset, itemId);

    if (item.id.toString().length === 0) {
        return <Redirect to="/student/tasks" />
    }

    let element: JSX.Element = <>{item.name}</>;
    let type = getItemType(props.task, props.itemset, item);

    switch (type) {
        case "one-choice":
            element = <StudentOneChoiceItem key={item.id} task={props.task} itemset={props.itemset} item={item} />
            break;
        case "video-instruction":
            element = <StudentVideoInstructionItem key={item.id} task={props.task} itemset={props.itemset} item={item} />
            break;
        case "find-error":
            element = <StudentFindErrorItem key={item.id} task={props.task} itemset={props.itemset} item={item} />
            break;
        case "video-recording":
            element = <StudentVideoRecording key={item.id} task={props.task} itemset={props.itemset} item={item} />
            break;
        case "combine":
            element = <CombineItem key={item.id} task={props.task} itemset={props.itemset} item={item} />
            break;
        case "organize":
            element = <StudentOrganizeItem key={item.id} task={props.task} itemset={props.itemset} item={item} />
            break;
        case "memory-game":
            element = <StudentMemoryGameItem key={item.id} task={props.task} itemset={props.itemset} item={item} />
            break;
        default:
            element = <>{`Tehtävätyyppiä ${item.type} ei löytynyt.`}</>
    }

    let ind = (props.itemset.items.indexOf(item)) + 1;

    return (
        <div className=" h-screen ">
            <ProgressBar itemCount={props.itemset.items.length} itemIndex={ind}/>
            {element}
        </div>
    );
}

function getItemType(task: Task, itemset: Itemset, item: Item): string {
    let type = item.type;
    type = type.length === 0 || type === "NONE" ? itemset.type : type;
    type = type.length === 0 || type === "NONE" ? task.type : type;
    return type;
}

export default StudentItem;
